module.exports = __webpack_public_path__ + "img/磨床1.577a43b9.jpg";